var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Hero Image")]),
      _c(
        "md-layout",
        { attrs: { "md-flex": "100" } },
        [
          _c("p", { staticClass: "massageInfo" }, [
            _vm._v(
              "This image will be shown as a background poster in Roku, must be 9x4 "
            )
          ]),
          _c(
            "md-layout",
            { attrs: { "md-flex": "90" } },
            [
              _c(
                "md-input-container",
                {
                  class: {
                    "md-input-invalid":
                      _vm.formSubmitted &&
                      !_vm.file &&
                      _vm.status === "public" &&
                      (!_vm.url || _vm.url === "false")
                  }
                },
                [
                  _c("label", [_vm._v(" " + _vm._s(_vm.label))]),
                  _c("md-file", {
                    attrs: { accept: "image/*" },
                    on: { selected: _vm.onFileSelected },
                    model: {
                      value: _vm.fileName,
                      callback: function($$v) {
                        _vm.fileName = $$v
                      },
                      expression: "fileName"
                    }
                  }),
                  _vm.formSubmitted && !_vm.validFormat
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          "You must select a valid image (the valid ones are: JPG, JPEG, BMP, PNG)"
                        )
                      ])
                    : _vm._e(),
                  _vm.formSubmitted && !_vm.file
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v("This field is required")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm.imgErrorShowText
                ? _c(
                    "span",
                    { staticClass: "md-error", style: { color: "#ff5722" } },
                    [_vm._v(_vm._s(_vm.imgErrorText))]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("md-layout", { attrs: { "md-flex": "10" } }, [
            _c(
              "div",
              { staticClass: "uploader" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-fab",
                    class: { "md-primary": _vm.done },
                    attrs: {
                      disabled:
                        !_vm.file ||
                        !_vm.uploadBtnEnabled ||
                        _vm.imgErrorShowText
                    },
                    on: { click: _vm.upload }
                  },
                  [
                    !_vm.done
                      ? _c("md-icon", {
                          attrs: { "md-iconset": "fa fa-cloud-upload-alt" }
                        })
                      : _vm._e(),
                    _vm.done
                      ? _c("md-icon", {
                          attrs: { "md-iconset": "fa fa-check" }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm.progress > 0 && !_vm.done
                  ? _c(
                      "md-theme",
                      { attrs: { "md-name": "blue" } },
                      [
                        _c("md-spinner", {
                          attrs: {
                            "md-size": 74,
                            "md-stroke": 2.2,
                            "md-progress": _vm.progress
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "imageContainer" },
        [
          !!_vm.url && _vm.url !== "false"
            ? _c("img", {
                attrs: { src: _vm.baseUrl + _vm.url, alt: "hero image" }
              })
            : _vm._e(),
          _c(
            "md-layout",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.progress > 0 && !_vm.done,
                  expression: "progress > 0 && !done"
                }
              ],
              staticClass: "select-loader",
              attrs: { "md-flex": "10", "md-align": "end" }
            },
            [
              _c("md-spinner", {
                staticClass: "md-accent",
                attrs: { "md-indeterminate": "md-indeterminate", "md-size": 25 }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ead552a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ead552a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/upload/HeroImageUploader.vue
// module id = 784
// module chunks = 0